import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { LockCardStackRoutes, LockCardStackScreenProps } from './type';
import { LockCardWebOneScreen } from './LockCardWebOne.screen';
import { LockCardNativeOneScreen } from './LockCardNativeOne.screen';
import { UnlockCardWebOneScreen } from './UnlockCardWebOne.screen';
import { UnlockCardNativeOneScreen } from './UnlockCardNativeOne.screen';

export interface LockCardProps {}
export const LockCardPlaced: React.FC<LockCardStackScreenProps<LockCardStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, account, tab, type, record, data, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return type == 'lock' ? (
      <LockCardNativeOneScreen onClose={onGoBack} account={account} tab={tab} record={record} data={data} refresh={refresh} />
    ) : (
      <UnlockCardNativeOneScreen onClose={onGoBack} account={account} tab={tab} record={record} data={data} refresh={refresh} />
    );
  }

  return type == 'lock' ? (
    <LockCardWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      record={record}
      data={data}
      refresh={refresh}
    />
  ) : (
    <UnlockCardWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      record={record}
      data={data}
      refresh={refresh}
    />
  );
};
